<template>
  <div class="footer-warning">
    <ul>
      <li v-for="item in list" v-bind:key="item.id" v-html="item.info"></li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          id: 0,
          info: `投資人應先審閱自動化投資顧問服務所揭露之所有相關文件，瞭解其內容、條款，以確保自身權益。投資人應認知投資工具有其內在限制與現實情況所存在的潛在落差，包括：(一)系統或程式之基本假設：投資人應體認系統本身有其限制與重要基本假設，但假設可能未必與事實或個案情節相符。 (二)提供產品範圍：投資人應了解系統提供之投資產品範圍的侷限性，致使產出的投資組合建議方案有限。投資人應理解自動化投資顧問服務之產出直接繫於投資人所提供之資訊，而投資人所提供資訊則影響系統之產出結果。投資人應注意自動化投資顧問服務系統因無法評估客戶之所有情況與環境，例如，年齡、經濟狀況與財務需要、投資經驗、其他資產、稅務概況，承受風險之意願，投資回收期間長短、現金需求，與投資目標等等，從而自動化投資顧問服務系統所提出之投資組合建議未必符合投資人個人的財務需要或目標。`
        },
        {
          id: 1,
          info: `本公司所提供之資訊，僅供接收人之參考用途。本公司當盡力提供正確之資訊，所載資料均來自或本諸我們相信可靠之來源，但對其完整性、即時性和正確性不做任何擔保，如有錯漏或疏忽，本公司或關係企業與其任何董事或受僱人，並不負任何法律責任。任何人因信賴此等資料而做出或改變投資決策，須自行承擔結果。本網頁所載資料或任何部份均不可以進行抄錄、翻印或另作派發。`
        },
        {
          id: 2,
          info: `<b>本境外基金經金融監督管理委員會核准或申報生效在國內募集及銷售，惟不表示絕無風險。基金經理公司以往之經理績效不保證基金之最低投資收益；基金經理公司除盡善良管理人之注意義務外，不負責本基金之盈虧，亦不保證最低之收益，投資人申購前應詳閱基金公開說明書。</b>`
        },
        {
          id: 3,
          info: `<b>由於高收益債券之信用評等未達投資等級或未經信用評等，且對利率變動的敏感度甚高，故本基金可能會因利率上升、市場流動性下降，或債券發行機構違約不支付本金、利息或破產而蒙受虧損。本基金不適合無法承擔相關風險之投資人。基金經理公司以往之經理績效不保證基金之最低投資收益；基金經理公司除盡善良管理人之注意義務外，不負責本基金之盈虧，亦不保證最低之收益，投資人申購前應詳閱基金公開說明書。本基金較適合投資屬性中風險承受度較高之投資人，投資人投資高收益債券為訴求基金不宜占其投資組合過高之比重，投資人應審慎評估。</b>`
        },
        {
          id: 4,
          info: `由於新興市場基金之主要投資風險除包含一般股票型基金之投資組合跌價與匯率風險外，與成熟市場相比須承受較高之政治與金融管理風險，而因市值及制度性因素，流動性風險也相對較高，新興市場投資組合波動性普遍高於成熟市場。基金投資均涉及風險且不負任何抵抗投資虧損之擔保。投資風險之詳細資料請參閱基金公開說明書。`
        },
        {
          id: 5,
          info: `<b>基金配息率不代表基金報酬率，且過去配息率不代表未來配息率；基金淨值可能因市場因素而上下波動，投資人於獲配息時，宜一併注意基金淨值之變動。基金的配息可能由基金的收益或本金中支付。任何涉及由本金支出的部份，可能導致原始投資金額減損。部分基金進行配息前未先扣除應負擔之費用。由本金支付配息之相關資料已揭露於本公司網站，投資人可至本公司網站(<a href="https://www.Franklin.com.tw" target="_blank">https://www.Franklin.com.tw</a>)查閱。</b>`
        },
        {
          id: 6,
          info: `投資基金所應承擔之相關風險及應負擔之費用(含分銷費用)已揭露於基金公開說明書及投資人須知中，投資人可至境外基金資訊觀測站(<a href="https://www.fundclear.com.tw/" target="_blank">https://www.fundclear.com.tw/</a>)下載，或逕向本公司網站(<a href="https://www.Franklin.com.tw" target="_blank">https://www.franklin.com.tw/</a>)查閱。`
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mptFooterWarning.vue